import { render, staticRenderFns } from "./UpdateInventoryModal.vue?vue&type=template&id=2ecb6316"
import script from "./UpdateInventoryModal.vue?vue&type=script&lang=js"
export * from "./UpdateInventoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports